import type React from 'react';

import './PolyLoader.css';

export interface AnimatedDotProps {
  delay?: number;
  fill: string;
  fillActive: string;
  d: string;
  duration?: number;
}

export const ANIMATION_DURATION = 1.2;

const AnimatedDot = ({
  delay,
  fill,
  fillActive,
  d,
  duration = ANIMATION_DURATION,
}: AnimatedDotProps) => (
  <path
    aria-hidden
    className="poly-loader-dot"
    d={d}
    style={
      {
        fill,
        '--dot-fill': fill,
        '--dot-fill-active': fillActive,
        '--dot-duration': `${duration}s`,
        '--dot-delay': delay !== undefined ? `${delay}s` : '0s',
      } as React.CSSProperties
    }
  />
);

export default AnimatedDot;
